import React from "react"

import { Dialog, DialogActions, DialogContent } from "@mui/material"

import { ButtonPrimary } from "../../../../../clux-ui/components"
import { ITEM_TYPES } from "../../config/constants"
import { DetectiveCluxConfig, Level, Suspects } from "../../config/interfaces"
import ClueCard from "../ClueCard"
import SpeechBubble from "../SpeechBubble"
import Tile from "../Tile"

import "./style.scss"

interface ConfirmationDialogProps {
  open: boolean
  suspects: Suspects
  /** Éléments de la solution : leurs descriptions n'ont jamais été piochées */
  solution: Suspects
  level: Level
  images: Pick<DetectiveCluxConfig["images"], "detective" | "roi">
  messages: DetectiveCluxConfig["messages"]
  onValidate: () => void
  onClose: () => void
}

const SUSPICION_ID = "dc-confirmation-suspicion"

/**
 * Modale de confirmation : le détective annonce ses soupçons, puis on affiche
 * les 3 tuiles restantes et les 3 indices qui n'ont pas été distribués.
 */
const ConfirmationDialog = ({
  open,
  suspects,
  solution,
  level,
  images,
  messages,
  onValidate,
  onClose,
}: ConfirmationDialogProps) => (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth="md"
    fullWidth
    aria-labelledby={SUSPICION_ID}
    className="dc-confirmation"
  >
    <DialogContent>
      <div className="dc-confirmation__dialogue">
        <SpeechBubble
          image={images.detective}
          speaker="Le détective Clux"
          message={messages.suspicion(suspects)}
          messageId={SUSPICION_ID}
        />
        <SpeechBubble
          image={images.roi}
          speaker="Le roi"
          message={messages.roiConfirmation}
          isReversed
        />
      </div>

      <ul className="dc-confirmation__list">
        {ITEM_TYPES.map(type => (
          <li key={type} className="dc-confirmation__row">
            <div className="dc-confirmation__tile">
              <Tile item={suspects[type]} />
            </div>
            <ClueCard
              title="Indice resté dans l'enveloppe"
              description={solution[type].descriptions[level]}
            />
          </li>
        ))}
      </ul>
    </DialogContent>

    <DialogActions className="dc-confirmation__actions">
      <ButtonPrimary onClick={onValidate}>Je valide mon choix</ButtonPrimary>
      <ButtonPrimary onClick={onClose}>
        Je retourne dans l'enquête
      </ButtonPrimary>
    </DialogActions>
  </Dialog>
)

export default ConfirmationDialog
